import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import {UserStatus} from "../../../models/userStatus";
import "./userStatusBlock.styl";
const template = require("./userStatusBlock.vue");

@Component({
  template: template
})
export default class UserStatusBlockComponent extends Vue {

  email: string = "";
  fullName: string = "";
  password: string = "";

  isLogging: boolean = false;

  @Prop({ default: false })
  miniflag: boolean;

  created(): void {
    if (this.$store.state.session.status === UserStatus.LoggedIn) {
      let user = this.$store.state.session.user;
      this.email = user.email;
      if (user.name && user.surname) {
        this.fullName = user.name + " " + user.surname;
      } else {
        this.fullName = "Utente Test";
      }
    }
  }

}

Vue.component("cmUserStatusBlock", UserStatusBlockComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/userStatusBlock/userStatusBlock.ts